export default __webpack_public_path__ + "static/media/table-up.c78e6b5a.svg";